export function updatePageMetaDataExps(list, exps, pageId) {
    return list.map(item => {
        const {
            type, metadata, id, children = [],
        } = item
        const { expression } = metadata || {}
        if (type && expression && (id === pageId)) {
            item.metadata.expression = exps
        }
        if (children) {
            item.children = updatePageMetaDataExps(children, exps, pageId)
        }
        return item
    })
}

export function updatePageMetaData(list, pageId, cb) {
    return list.map(item => {
        const { type, id, children = [] } = item
        if (type && (id === pageId)) {
            item = cb(item)
        }
        if (children) {
            item.children = updatePageMetaData(children, pageId, cb)
        }
        return item
    })
}
